import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipsisIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 20 4",
	style: { enableBackground: "new 0 0 20 4" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.ellipsis-icon-st0{fill:currentColor;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "ellipsis-icon-st0",
			d: "M10,4c1.1,0,2-0.9,2-2s-0.9-2-2-2C8.9,0,8,0.9,8,2S8.9,4,10,4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "ellipsis-icon-st0",
			d: "M18,4c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S16.9,4,18,4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "ellipsis-icon-st0",
			d: "M2,4c1.1,0,2-0.9,2-2S3.1,0,2,0S0,0.9,0,2S0.9,4,2,4z"
		})
	]
});
export default SvgEllipsisIcon;
